import React from "react";
import { List } from "immutable";
import CardListWithoutTitle from "./CardListWithoutTitle";
const dummyDataForShell = size => new List().setSize(size);
const CardListShell = ({ size = 3 }) => {
    return <CardListWithoutTitle cards={dummyDataForShell(size)}/>;
};
export default CardListShell;
